import * as fabric from 'fabric';

// A delete badge that removes the issue.
export const createMarkerDeleteControl = (onDelete: (id: string | undefined) => void) =>
  new fabric.Control({
    // Anchored on the circle's top-right corner.
    x: 0.5,
    y: -0.5,
    offsetX: -2,
    offsetY: 2,
    cursorStyle: 'pointer',
    sizeX: 13,
    sizeY: 13,
    render: (ctx, left, top) => {
      ctx.save();
      ctx.translate(left, top);
      ctx.fillStyle = '#EF4444';
      ctx.beginPath();
      ctx.arc(0, 0, 6.5, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = '#FFFFFF';
      ctx.lineWidth = 1.6;
      ctx.lineCap = 'round';
      const r = 2.6;
      ctx.beginPath();
      ctx.moveTo(-r, -r);
      ctx.lineTo(r, r);
      ctx.moveTo(r, -r);
      ctx.lineTo(-r, r);
      ctx.stroke();
      ctx.restore();
    },
    mouseUpHandler: (_e, transform) => {
      onDelete(transform.target.id);
      return true;
    }
  });
